import React from "react";
import {
  InboxOutlined,
  DollarCircleOutlined,
  WarningOutlined,
  AlertOutlined,
} from "@ant-design/icons";
import { Skeleton, Tooltip } from "antd";
import { useSelector } from "react-redux";
import canSeeFinance from "../../../../utils/canSeeFinance";
import "./rapportKPIsStock.scss";

const formatNumber = (v) =>
  v == null ? "-" : new Intl.NumberFormat("fr-FR").format(v);

const RapportKPIsStock = ({ kpis, loading }) => {
  const user = useSelector((state) => state.user?.currentUser);
  const totalAlertes = (kpis?.alerts || 0);

  const items = [
    {
      label: "Stock total",
      value: formatNumber(kpis?.total_stock || 0),
      icon: <InboxOutlined />,
      color: "#3b82f6",
      bg: "#eff6ff",
      tooltip: "Nombre total de paires en stock (toutes variantes confondues)"
    },
    ...(canSeeFinance(user)
      ? [{
          label: "Valeur du stock",
          value: `${formatNumber(kpis?.valeur_stock || 0)} $`,
          icon: <DollarCircleOutlined />,
          color: "#10b981",
          bg: "#ecfdf5",
          tooltip: "Valeur commerciale du stock = stock × prix de vente"
        }]
      : []),
/*     {
      label: `Sorties (période)`,
      value: formatNumber(kpis?.sortieJour || 0),
      icon: <ExportOutlined />,
      color: "#f59e0b",
      bg: "#fffbeb",
      tooltip: `Nombre de paires vendues sur la période`
    }, */
    {
      label: "Stock faible",
      value: formatNumber(kpis?.stock_faible || 0),
      icon: <AlertOutlined />,
      color: "#f59e0b",
      bg: "#fef3c7",
      tooltip: "Variantes avec stock ≤ seuil minimum"
    },
    {
      label: "Total alertes",
      value: formatNumber(totalAlertes),
      icon: <WarningOutlined />,
      color: "#ef4444",
      bg: "#fee2e2",
      tooltip: "Ruptures + stocks faibles (à surveiller)"
    },
  ];

  return (
    <section className="rapport-kpis-stock">
      <div className="kpi-grid">
        {items.map((k, i) => (
          <div className="kpi-card" key={i}>
            <div
              className="kpi-icon"
              style={{
                background: k.bg,
                color: k.color,
              }}
            >
              {k.icon}
            </div>

            <div className="kpi-info">
              <div className="kpi-label">
                {loading ? (
                  <Skeleton.Input active size="small" style={{ width: 140 }} />
                ) : (
                  <Tooltip title={k.tooltip}>
                    <span>{k.label}</span>
                  </Tooltip>
                )}
              </div>

              <div className="kpi-value">
                {loading ? (
                  <Skeleton.Input active size="default" style={{ width: 100, height: 24 }} />
                ) : (
                  k.value
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RapportKPIsStock;